import {
  CUSTOM_FIELD_FORM_BOOKING,
  CUSTOM_FIELD_FORM_SUBSCRIPTION
} from '../constants/backend';

import { safe } from '../utils/utils';

const defaultState = {
  memberFields: [],
  memberValues: [],
  memberFormValues: {},
  bookingFields: [],
  bookingValues: []
};

export const reducerType = 'customFields';

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case `${reducerType}/GET_${CUSTOM_FIELD_FORM_SUBSCRIPTION}_FIELDS_SUCCESS`: {
      const data = action.payload.data;
      const { [CUSTOM_FIELD_FORM_SUBSCRIPTION]: memberFields } = data || {};

      state = {
        ...state,
        memberFields: memberFields || []
      };

      break;
    }

    case `${reducerType}/GET_${CUSTOM_FIELD_FORM_BOOKING}_FIELDS_SUCCESS`: {
      const data = action.payload.data;
      const { [CUSTOM_FIELD_FORM_BOOKING]: bookingFields } = data || {};

      state = {
        ...state,
        bookingFields: bookingFields || []
      };

      break;
    }

    case 'user/UPDATE_INFO_SUCCESS':
    case 'user/GET_INFO_SUCCESS': {
      state = {
        ...state,
        memberValues: safe(() => action.payload.data.memberCustomValues) || []
      };
      break;
    }

    case `${reducerType}/SET_MEMBER_FORM_VALUES`: {
      state = {
        ...state,
        memberFormValues: action.payload || {}
      };
      break;
    }

    // Parity with formMirror: clear the mirrored RFF values on profile-flow exit.
    // The migration wired CLEAR_PROFILE_FORM_DATA into formMirror but missed it
    // here, leaving stale memberFormValues for consumers after the form unmounts.
    case 'user/CLEAR_PROFILE_FORM_DATA': {
      state = {
        ...state,
        memberFormValues: {}
      };
      break;
    }

    default: {
      break;
    }
  }

  return state;
}
